<template>
  <div>
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <h1 class="text-center">Thanks!</h1>
      </div>
    </div>

    <div class="container-fluid">
      <div class="dashboard-block text-center">
        <div class="row m-b-md">
          <div class="col-sm-offset-1 col-sm-10 col-md-offset-2 col-md-8 col-lg-offset-3 col-lg-6">
            <div class="payment-container text-center">

              <p class="lead">
                We have received your {{ paymentType }} payment<br />
                for booking #{{ booking.id | padded('0', 5) }}.
              </p>

              <p>A receipt will be emailed to you. Please allow 3 - 5 business days.</p>

              <div class="decorative-divider"></div>

              <p class="paid-amount">{{ paymentAmount | currency() }}</p>
            </div>
          </div>
        </div>

        <router-link :to="{ name: 'bookings.show', params: { id: booking.id } }">
          <i class="fa fa-angle-left"></i> &nbsp; Back to booking.
        </router-link>

        <div v-if="$userIsAdmin" class="row m-b-md" style="padding-top: 20px;">
          <div class="col-sm-offset-1 col-sm-10 col-md-offset-2 col-md-8 col-lg-offset-3 col-lg-6">
            <div class="payment-container text-center">

              <p class="lead">
                Admin Options
              </p>
              <ladda-button
                class="btn btn-sm btn-info"
                :click="handleMarkPaymentAsUnpaid">
                {{ bothPaymentsShareSameTransaction ? 'Mark Both Payments As Unpaid' : 'Mark Payment As Unpaid' }}
              </ladda-button>
              <p v-if="bothPaymentsShareSameTransaction" style="color: #919191; font-size: 13px;">As the payments were paid together, they must both be marked unpaid</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { find } from 'lodash'

export default {
  props: {
    paymentViewing: {
      required: true,
      type: Object
    }
  },

  methods: {
    ...mapActions('booking', ['markPaymentUnpaid']),
    handleMarkPaymentAsUnpaid () {
      return this.markPaymentUnpaid({ transactionId: this.paymentViewing.transaction.id })
    }
  },

  computed: {
    ...mapState('booking', ['booking']),

    /**
     * Determines if both payments share the same transaction.
     *
     * We want to show them that both have been paid consistently so we need to know if they share
     * the same transaction.
     *
     * @return bool
     */
    bothPaymentsShareSameTransaction () {
      return this.paymentViewing.transaction !== null &&
        this.paymentNotViewing &&
        this.paymentNotViewing.transaction !== null &&
        this.paymentViewing.transaction.id === this.paymentNotViewing.transaction.id
    },

    /**
     * Get the payment that we are not viewing.
     *
     * This is so we can compare the payments and their transaction.
     *
     * @return object
     */
    paymentNotViewing () {
      return find(this.booking.payments, payment => payment.id !== this.paymentViewing.id)
    },

    /**
     * Get the type of payment we are showing a success for.
     *
     * If both payments share the same transaction then we show "deposit + final" as that is what they
     * have paid for.
     *
     * @return string
     */
    paymentType () {
      if (this.paymentViewing.type === 'full') {
        return this.paymentViewing.type
      }
      if (this.bothPaymentsShareSameTransaction) {
        return 'deposit + final'
      }

      return this.paymentViewing.type
    },

    /**
     * Get the payment amount we are showing a success for.
     *
     * We can always go off of the transaction amount from the viewing payment as it will either be
     * a combination of both if we paid for both in the same transaction or it will be just
     * the amount we paid for the payment we are viewing.
     *
     * @return float
     */
    paymentAmount () {
      return this.paymentViewing.transaction.amount
    }
  }
}
</script>
